import values from 'lodash/values'

import legalEntities from 'modules/core/store/collections/legalEntities'

import { ALLOWED_COUNTRIES as PayrollAddonCountries } from 'modules/payroll_bundle/store/models/PayrollBundle'

const hideCountrySelector = () => {
  const legalEntitiesCountries = legalEntities.map((legalEntity) => legalEntity.country)
  const onlyOneLe = legalEntitiesCountries.length === 1

  // If company has only one Legal Entity
  if (onlyOneLe) return onlyOneLe

  const allLeSameCountry = legalEntitiesCountries.every((le) => le === legalEntitiesCountries[0])

  // If company has multiple LEs in the same country
  if (allLeSameCountry) return allLeSameCountry

  const addonCountries = values(PayrollAddonCountries)

  const availableCountries = legalEntitiesCountries.map((country) =>
    addonCountries.includes(country) ? country : PayrollAddonCountries.other
  )

  // If company has multiple LEs in countries without country default payroll (PayrollAddonCountries)
  const notAvailableCountries = availableCountries.every(
    (country) => country === PayrollAddonCountries.other
  )

  return notAvailableCountries
}

export default hideCountrySelector
